import React, { useState } from "react";
import { Form, Formik } from "formik";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import * as yup from "yup";

import Alert from "../components/Alert";
import Button from "../components/Button";
import LabeledFormField from "../components/LabeledFormField";
import { axiosClient } from "../redux_axios_middleware";

const validationSchema = yup.object().shape({
  password: yup.string().min(12).required("Password is required"),
  passwordConfirm: yup.string().required("Please confirm the password"),
});

export default function SetPassword({ match }) {
  const [passwordChanged, setPasswordChanged] = useState(false);

  if (passwordChanged) {
    return (
      <Alert color="success">
        Your password was reset. <Link to="/sign-in">Sign in</Link>
      </Alert>
    );
  }

  const onSubmit = async (values, actions) => {
    if (values.password !== values.passwordConfirm) {
      actions.setFieldError("passwordConfirm", "Password mismatch");
      actions.setSubmitting(false);
      return;
    }

    try {
      await axiosClient.post(
        `/reset-password.json/${encodeURIComponent(match.params.token)}`,
        {
          password: values.password,
          password_confirm: values.passwordConfirm,
        },
      );
      setPasswordChanged(true);
    } catch (error) {
      const errors = error?.response?.data?.response?.errors || {};
      actions.setErrors({
        password: errors.password,
        passwordConfirm: errors.password_confirm,
      });
      actions.setStatus(errors.token?.[0] || "Could not reset password");
      actions.setSubmitting(false);
    }
  };

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 mt-3">
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl mb-3">Choose a new password</h1>
        <Formik
          initialValues={{ password: "", passwordConfirm: "" }}
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={onSubmit}
        >
          {({ isSubmitting, status }) => (
            <Form>
              {status && <Alert color="danger">{status}</Alert>}
              <LabeledFormField
                label="New Password"
                type="password"
                name="password"
              />
              <LabeledFormField
                label="Confirm Password"
                type="password"
                name="passwordConfirm"
              />
              <Button className="mt-4" type="submit" disabled={isSubmitting}>
                Reset Password
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

SetPassword.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
